// @ts-nocheck
import React, {ChangeEvent, FormEvent, useMemo} from "react";
import {GuestFormBuilder, IFormField} from "./guestFormBuilder";
import "../../../assets/scss/components/subscription/guestLeadForm.scss";
import EdButton from "../../generic/edButton";
import {IPContext} from "../infinityPlan";
import {getLeadMasterDetails, saveLeadInfo_v1} from "../../service/postLogin/leadAPIService";
import {useQuery} from "../../service/urlHelper";

interface IGuestFormFields {
    Name: string;
    MobileNumber: string;
    Email: string;
}

export const GuestLeadForm: React.FC = () => {
    const [FormFields, setFormFields] = React.useState<IGuestFormFields>({Name: "", MobileNumber: "", Email: ""});
    const [IsFormSubmitted, setIsFormSubmitted] = React.useState<boolean>(false);
    const [IsFormValid, setIsFormValid] = React.useState<boolean>(true);

    const {setShowModal, showModalFunc} = React.useContext(IPContext);
    const query = useQuery();
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const name: string = event.target.name;
        setFormFields({...FormFields, [name as keyof IGuestFormFields]: event.target.value});
    }
    const handleFormSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const fields = Object.keys(e.currentTarget);
        let FormValid: boolean = true;
        // console.log(fields);
        setIsFormValid(true);
        if (fields.length) {
            for (let i = 0; i < GuestFormBuilder.length; i++) {
                if (!e.currentTarget[fields[i]].validity.valid) {
                    // console.log(e.currentTarget[fields[i]].validity)
                    setIsFormValid(false);
                    FormValid = false;
                    return false;
                }
            }
        }
        if (FormValid) {
            setIsFormSubmitted(true);
            let resp = await getLeadMasterDetails("10");
            if(resp) {
            let req = 
            {
                Email: FormFields.Email,
                Name: FormFields.Name,
                Phone: FormFields.MobileNumber,
                //City: "",
                ProductId: resp? resp[0].product_code : "",
				CategoryId: resp? resp[0].category_code : "",
				SubCategoryId: resp? resp[0].subcategory_code : "",
				SourceId: resp? resp[0].source_code : "",
				SubSourceId: resp? resp[0].subsource_code: "",
                //elliance: false
                OfferId : 0,
                EntityType : ""  
            };
            window.history.pushState({}, "", window.location.href.split("?")[0]);
            saveLeadInfo_v1((res: any) => {
              if(res) {
                if (res.indexOf("Lead created") >= 0 || res.indexOf("Lead Created") >= 0) {
                    setShowModal(false);
                    showModalFunc(true);
                    setIsFormValid(true);
                    setIsFormSubmitted(false);
                    setFormFields({Name: "", MobileNumber: "", Email: ""});
                }
                else {
                    setShowModal(false);
                    showModalFunc(true);
                    setIsFormValid(true);
                    setIsFormSubmitted(false);
                    setFormFields({Name: "", MobileNumber: "", Email: ""});
                }
              }
            }, req);
          }
        }
    }


    return <form onSubmit={handleFormSubmit}
                 noValidate
                 autoComplete={"off"}
                 className={"guest_lead_form"}>
        {GuestFormBuilder.map((field: IFormField, i: number) => {
            return <div key={i} className={"fieldset mg-b30"}>
                <label className={"label"}
                       htmlFor={field.Key as keyof IGuestFormFields}>{field.FieldName}</label>
                <div className={"flexIt"}>
                    {field.Key === "MobileNumber" && <span
                        className={"prefix " + ((!IsFormValid && (!FormFields[field.Key as keyof IGuestFormFields] || !(new RegExp(field.Validation).test(FormFields[field.Key as keyof IGuestFormFields])))) ? 'error' : '')}

                    >+91</span>}
                    <input type={field.FieldType}
                           value={FormFields[field.Key as keyof IGuestFormFields]}
                           required={field.Required}
                           pattern={field.Validation}
                           className={"field " + ((!IsFormValid && (!FormFields[field.Key as keyof IGuestFormFields] || !(new RegExp(field.Validation).test(FormFields[field.Key as keyof IGuestFormFields])))) ? 'error' : '')}
                           placeholder={field.Placeholder}
                           maxLength={field.MaxLength}
                           onChange={(e) => {
                               if (e.target.value && field.AllowRegex && !(new RegExp(field.AllowRegex).test(e.target.value))) {
                                   return;
                               } else {
                                   handleChange(e);
                               }
                           }}
                           id={field.Key as keyof IGuestFormFields}
                           name={field.Key as keyof IGuestFormFields}/>
                </div>
                {!IsFormValid &&
                <label className={"errMsg"}>
                    {field.Key === "MobileNumber" && <span className={"prefix"}></span>}

                    {!FormFields[field.Key as keyof IGuestFormFields] ?
                        <>{field.Message.empty}</> :
                        (
                            !(new RegExp(field.Validation).test(FormFields[field.Key as keyof IGuestFormFields])) && <>{field.Message.error}</>
                        )
                    }
                </label>
                }
            </div>
        })}
        {/*CTA - form buttons*/}
        <div className={"taCenter form_buttons"}>
            <div className={"mg-t20"}>
                <EdButton value={"Submit"} btnTyp={"primary"} className={"guest_form_submit"}
                          disabled={IsFormSubmitted}/>
            </div>
            <div className={"mg-t30 cancel_div_block"}>
                <EdButton type={"button"} value={"Cancel"} btnTyp={"blue-link"}
                          className={"guest_form_cancel"}
                          onClick={() => setShowModal(false)}/>
            </div>
        </div>

    </form>
}
export default GuestLeadForm;
